import { useQuery } from "@tanstack/react-query";

import api from "@/shared/api";
import { Data } from "@/shared/types.ts";
import { CourierLocation } from "@/features/courier-map/type.ts";

const KEY = "courier_locations";

/** Приложение курьера шлёт точку раз в минуту — обновляем карту чаще, чем протухает TTL. */
export const REFETCH_INTERVAL = 20_000;

export function useCourierLocations(cityId?: number) {
  return useQuery<Data<CourierLocation[]>>({
    queryKey: [KEY, cityId ?? 0],
    queryFn: (ctx) =>
      api
        .get<
          Data<CourierLocation[]>
        >(`/api/v1/admin/couriers/locations${cityId ? `?cityId=${cityId}` : ""}`, { signal: ctx.signal })
        .json(),
    refetchInterval: REFETCH_INTERVAL,
    initialData: { data: [] } as unknown as Data<CourierLocation[]>,
  });
}
